module.exports = __webpack_public_path__ + "static/media/googleplay_white.68962557.svg";